import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { getResponseMessage } from '../../../../../utils/utils';
import { useFormatMessage } from '../../../../../hooks';
import { getLocation, getLocationGeocode } from '../../../../../crud/location.crud';

export type Location = {
  fullAddress?: string;
  address: string;
  description?: string;
  lat: number;
  lng: number;
  city?: string;
  createdAt?: Date;
  province?: string;
};

export const useGetLocations = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loadingLocations, setLoading] = useState(false);
  const [locations, setLocations] = useState<Location[]>([]);
  const fm = useFormatMessage();

  const fetchGeocode = async (value: string) => {
    setLoading(true);
    getLocationGeocode(`Ингушетия, ${value}`)
      .then(res => {
        setLocations(
          googleDataToEntities(res.data.response.GeoObjectCollection.featureMember)
        );
      })
      .catch(e => {
        enqueueSnackbar(`${fm('ERROR')}: ${getResponseMessage(e)}`);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchSuggest = async (value: string, onlyCity?: boolean) => {
    setLoading(true);
    getLocation(`${onlyCity ? 'Ингушетия, ' : ''}${value}`)
      .then(res => {
        setLocations(formatSuggestData(res.data.results));
      })
      .catch(e => {
        fetchGeocode(value);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const clearLocations = () => setLocations([]);

  return {
    fetchSuggest,
    loadingLocations,
    locations,
    clearLocations,
  };
};

export function googleDataToEntities(data: any) {
  try {
    const res = data
      .filter(
        (i: any) =>
          i.GeoObject.metaDataProperty?.GeocoderMetaData?.Address?.country_code === 'RU'
      )
      .map((i: any) => ({
        fullAddress: i.GeoObject.metaDataProperty.GeocoderMetaData.Address.formatted,
        address: i.GeoObject.name,
        description: i.GeoObject.description,
        lat: Number(i.GeoObject.Point.pos.split(' ')[1]),
        lng: Number(i.GeoObject.Point.pos.split(' ')[0]),
        province:
          i.GeoObject.metaDataProperty?.GeocoderMetaData?.Address?.Components?.find(
            (i: any) => i?.kind === 'locality'
          )?.name ||
          i.GeoObject.metaDataProperty?.GeocoderMetaData?.Address?.Components?.find(
            (i: any) => i?.kind === 'province'
          )?.name ||
          '',
        city:
          i.GeoObject.metaDataProperty?.GeocoderMetaData?.Address?.Components?.find(
            (i: any) => i?.kind === 'locality'
          )?.name || '',
      }));
    return res;

    // return data.results.map(i => {
    //   return {
    //     address: i.title.text,
    //     description: i.subtitle?.text || '',
    //     // lng: i.geometry.location.log,
    //     // lat: i.geometry.location.lat,
    //   };
    // });
  } catch (e) {
    return [];
  }
}

export function formatSuggestData(data: any) {
  try {
    const res = data.map((i: any) => {
      return {
        address: i.title.text,
        description: i.subtitle.text || '',
        formatted_address: i.address.formatted_address,
        province:
          i.address.component.find((i: any) => !!i?.kind?.find((a: any) => a === 'LOCALITY'))
            ?.name ||
          i.address.component.find((i: any) => !!i?.kind?.find((a: any) => a === 'PROVINCE'))
            ?.name ||
          '',
        city:
          i.address.component.find((i: any) => !!i?.kind?.find((a: any) => a === 'LOCALITY'))
            ?.name || '',
      };
    });
    return res;
  } catch (e) {
    return [];
  }
}
